import React from 'react';

const PageNotFound: React.FC = () => {
  return <div>Pagina non trovata</div>;
};

export default PageNotFound;
